/**
 * Inverted palettes for dark mode so legacy `grey.700`, `grey.100`, `blue.600` etc.
 * resolve to readable light text / dark surfaces.
 */
export const DARK_GREY = {
  50: '#020617',
  100: '#0f172a',
  200: '#1e293b',
  300: '#334155',
  400: '#475569',
  500: '#64748b',
  600: '#94a3b8',
  700: '#cbd5e1',
  800: '#e2e8f0',
  900: '#f1f5f9',
  A100: '#f8fafc',
  A200: '#e2e8f0',
  A400: '#94a3b8',
  A700: '#64748b',
};

/** Legacy pages use blue.600 for headings — map to lighter blues in dark mode */
export const DARK_BLUE = {
  50: '#0c1929',
  100: '#0f2744',
  200: '#1e3a5f',
  300: '#1d4ed8',
  400: '#2563eb',
  500: '#3b82f6',
  600: '#93c5fd',
  700: '#bfdbfe',
  800: '#dbeafe',
  900: '#eff6ff',
  A100: '#dbeafe',
  A200: '#bfdbfe',
  A400: '#60a5fa',
  A700: '#1d4ed8',
};
